import React from 'react';
import PropTypes from 'prop-types';

import SkeletonBlock from 'Components/Skeleton/SkeletonBlock';

const PRODUCT_CARDS = 6;

/**
 * The layout bundle and pick-and-mix pages share, for their skeletons: on desktop (lg and up) a product grid with
 * the cover and buy panel beside it, as in BundleDesktopLayout and PickAndMixDesktopLayout; below lg the name, then
 * the cover and buy panel, then the products. The real desktop pages put the name under this, below the fold.
 * Slots: `name` (text), plus whatever `cover` renders.
 */
export default function SkeletonBundleLayout({ cover, pills }) {
  return (
    <div className="container SkeletonBundleLayout">
      <SkeletonBlock text tag="h1" slot="name" className="SkeletonBundleLayout__name d-lg-none" />

      <aside className="SkeletonBundleLayout__aside">
        <div className="responsive-image responsive-image--16by9 SkeletonBundleLayout__cover">
          {cover}
        </div>
        <div className="SkeletonBundleLayout__details">
          <SkeletonBlock className="SkeletonBundleLayout__message" />
          <SkeletonBlock className="SkeletonBundleLayout__tiers" />
          <SkeletonBlock className="SkeletonBundleLayout__button" />
        </div>
      </aside>

      <section className="SkeletonBundleLayout__products">
        {pills &&
          <SkeletonBlock className="SkeletonBundleLayout__pills d-none d-lg-block" />
        }
        {/* Cards per row as in BundleRedesignTieredProducts and PickAndMixHits: two on lg, otherwise three (two on xs) */}
        <div className="row">
          {[...Array(PRODUCT_CARDS).keys()].map(i =>
            <div className="col-6 col-md-4 col-lg-6 col-xl-4" key={i}>
              <div className="fake-hit-card">
                <div className="responsive-image responsive-image--16by9" />
                <div className="fake-card-strip" />
              </div>
            </div>,
          )}
        </div>
      </section>
    </div>
  );
}

SkeletonBundleLayout.propTypes = {
  cover: PropTypes.node.isRequired,
  // The tier pills above a tiered bundle's products (lg and up)
  pills: PropTypes.bool,
};

SkeletonBundleLayout.defaultProps = {
  pills: false,
};
